import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

console.log(
	`%c

██████    █████
██   ██  ██
██   ██  ██
██████    █████` +
		`%c

███████████████` +
		`
%c
Diario de Cádiz
J.A. Álvarez ${new Date().getFullYear()}

`,
	'font-family: monospace; font-size: 12px; line-height: 12px',
	'font-family: monospace; font-size: 12px; color: #CF2D26; line-height: 12px',
	'display: block'
);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js